import { useNavigate } from "react-router";
import restaurants from "../data/restaurants.json";

export default function RestaurantPage() {
    const navigate = useNavigate();

    return (
        <div className="container text-center mt-4">
            <h2 className="mb-4 fw-semibold">Tillgängliga restauranger</h2>
            <div className="d-flex flex-wrap justify-content-center gap-3">
            {restaurants.slice(0, 2).map((restaurant) => (
                    <div 
                        key={restaurant.slug} 
                        className="p-3 border rounded-lg shadow-sm restaurant-card text-center"
                        style={{ width: "250px", cursor: "pointer", transition: "0.3s" }}
                        onClick={() => navigate(`/${restaurant.slug}`)}
                    >
                        <h5 className="m-0 fw-bold">{restaurant.name}</h5>
                    </div>
                ))}

            </div>
        </div>
    );
}
